import React from "react";
import Modal from "react-bootstrap/Modal";
import Barcode from "react-barcode";
import { formatNumber } from "utils/currencyFormat";
import ReactToPrint from "react-to-print";

class InMaVachTaiSan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleEscKey = this.handleEscKey.bind(this); // Gọi hàm xử lý phím Esc
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleEscKey); // Lắng nghe sự kiện nhấn phím
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleEscKey); // Xóa lắng nghe sự kiện khi component unmount
  }

  handleEscKey(event) {
    if (event.key === "Escape") {
      if (this.props.inmavachtaisan.showModalInMaVach)
        this.props.showInMaVachTaiSan(); // Gọi hàm để đóng modal khi nhấn phím Esc
    }
  }
  renderListMaVach = () => {
    let { data } = this.props;
    if (!data.MaTaiSan) return;
    var lstTaiSan = data.MaTaiSan.split(",");
    var lstTenTaiSan = data.TenTaiSan.split(",");
    let { CustomerName, SoTienVayConLai, Code } = data;
    return lstTaiSan.map((item, index) => {
      return (
        <div class="col-sm-12" key={"MaVach" + index}>
          <div
            ref={(el) => (this["componentRef" + index] = el)}
            style={{
              display: "flex",
              position: "relative",
              width: 200,
              margin: "auto",
              justifyContent: "center",
            }}
          >
            <table class="table" style={{ border: "0px" }}>
              <tbody>
                <tr>
                  <td style={{ border: "0px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 15,
                      }}
                    >
                      <p
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          fontSize: "14px",
                          mozTransform: "rotate(-90deg)",
                          mozTransformOrigin: "center center",
                          webkitTransform: "rotate(-90deg)",
                          webkitTransformOrigin: "center center",
                          msTransform: "rotate(-90deg)",
                          msTransformOrigin: "center center",
                          color: "#2B335E",
                          fontWeight: "900",
                          margin: "0px",
                          padding: "0px",
                        }}
                      >
                        {formatNumber(SoTienVayConLai)} VND
                      </p>
                    </div>
                  </td>
                  <td style={{ border: "0px" }}>
                    <div style={{ display: "block" }}>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px 0 5px 0",
                          padding: "0px",
                          color: "#2B335E",
                          fontWeight: "900",
                        }}
                      >
                        {Code}
                      </p>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px",
                          padding: "0px",
                        }}
                      >
                        <Barcode
                          width={1}
                          value={item}
                          fontSize={16}
                          height={50}
                        />
                      </p>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px 0 0px 0",
                          padding: "0px",
                          color: "#2B335E",
                          fontWeight: "900",
                        }}
                      >
                        {CustomerName}
                      </p>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px 0 5px 0",
                          padding: "0px",
                          color: "#2B335E",
                          fontWeight: "900",
                        }}
                      >
                        {lstTenTaiSan[index]}
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="footer-barcode text-center">
            <ReactToPrint
              trigger={() => {
                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                // to the root node of the returned component as it will be overwritten.
                return (
                  <button
                    type="button"
                    className="btn btn-new-main btn-checknew"
                  >
                    &nbsp;
                    <img src="/app-assets/images/icon-in-danh-sach.png" />
                    &nbsp; In mã&nbsp;
                  </button>
                );
              }}
              content={() => this["componentRef" + index]}
              copyStyles={false}
            />
          </div>
        </div>
      );
    });
  };
  render() {
    let props = this.props;
    let { inmavachtaisan, data, showInMaVachTaiSan } = props;
    let { showModalInMaVach } = inmavachtaisan;
    //showModalInMaVach;
    return (
      <Modal
        show={showModalInMaVach}
        size="modal-dialog modal-lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-in-ma-vach-v2.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              In mã vạch
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={showInMaVachTaiSan}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="form-body">
                <div class="form-barcode">
                  <div class="row" id="barCodeData">
                    {this.renderListMaVach()}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={showInMaVachTaiSan}
          >
            &nbsp;
            <i class="mdi mdi-close"></i>
            &nbsp; Đóng&nbsp;
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default InMaVachTaiSan;
